import { VisibilityOffOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import { graphql, type DocumentType } from '@/gql';

import { useMutation } from '@/hooks/mutationWithSnackbar';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

const ENABLE_DOWNLOAD_OF_FILE_MUTATION = graphql(`
  mutation EnableDownloadOfFile($data: EnableDownloadOfFileInput) {
    enableDownloadOfFile(params: $data) {
      file {
        ...fileFields
      }
    }
  }
`);

const ENABLE_DOWNLOAD_OF_FILE_FILE_FRAGMENT = graphql(`
  fragment enableDownloadOfFileFileFields on File {
    ...fileFields
  }
`);

interface Props {
  file: DocumentType<typeof ENABLE_DOWNLOAD_OF_FILE_FILE_FRAGMENT>;
  canPreventDownload: boolean;
  canPreventDownloadRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const EnableDownloadOfFileMenuItem = ({
  file,
  canPreventDownload,
  canPreventDownloadRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const [enableDownloadOfFile] = useMutation(ENABLE_DOWNLOAD_OF_FILE_MUTATION, {
    onCompleted: onClose,
    optimisticResponse: {
      enableDownloadOfFile: {
        __typename: 'EnableDownloadOfFileResult',
        file: {
          ...file,
          preventDownload: false,
        },
      },
    },
  });

  return (
    <MaybeUsableMenuItem
      isUsable={canPreventDownload}
      isExpectedUsable={canPreventDownloadRoot}
      unusableExplanation={unusableExplanation}
      onClick={() => {
        onClose();
        enableDownloadOfFile({ variables: { data: { file: file._id } } });
      }}
    >
      <ListItemIcon>
        <VisibilityOffOutlined />
      </ListItemIcon>
      <ListItemText primary="Enable Downloading" />
    </MaybeUsableMenuItem>
  );
};
